import Frame from "../components/Frame";
import { CheckIcon } from "../components/Icons";
import ui from "../components/ui.module.css";
import { purposeLabel } from "../data/workLabels";

// Finished work set outside a lesson. It is saved; the teacher sees it. No
// score, no right or wrong here: that is the teacher's, or the policy's, to
// give later in My Learning.
const AssignmentDone = ({ assignment, onDone }) => (
  <Frame centered>
    <span className={`${ui.bigIcon} ${ui.pop}`}>
      <CheckIcon size={72} />
    </span>
    <h1 className={ui.learnerTitle}>{purposeLabel(assignment?.purpose)} finished</h1>
    <p className={ui.subline}>Your work is saved. Your teacher can see it.</p>
    <button type="button" className={`${ui.button} ${ui.large} ${ui.primary}`} onClick={onDone} autoFocus>
      Back to my work
    </button>
  </Frame>
);

export default AssignmentDone;
